<template>
  <div class="risk-control-operator">
    <el-select
      :value="value"
      :disabled="readonly"
      filterable
      placeholder="请选择风控处理人"
      style="width: 100%;"
      @input="handleInput"
    >
      <el-option-group v-for="group in usersByDept" :key="group.deptId" :label="group.deptName">
        <el-option
          v-for="u in group.users"
          :key="u.id"
          :label="u.nickname || u.username"
          :value="u.id"
        >
          <span>{{ u.nickname || u.username }}</span>
          <span v-if="u.username" style="float: right; color: #909399; font-size: 12px;">{{ u.username }}</span>
        </el-option>
      </el-option-group>
    </el-select>
  </div>
</template>

<script>
import { getAllUsers } from '../../api/user'
import { getAllDepartments } from '../../api/department'
import { getAllUserDeptRelations } from '../../api/user'

export default {
  name: 'RiskControlOperator',
  props: {
    value: { default: null },
    readonly: { type: Boolean, default: false }
  },
  data() {
    return {
      usersByDept: []
    }
  },
  created() {
    this.loadUsersByDept()
  },
  methods: {
    async loadUsersByDept() {
      try {
        const [usersRes, deptsRes, relationsRes] = await Promise.all([
          getAllUsers().catch(() => ({ data: [] })),
          getAllDepartments().catch(() => ({ data: [] })),
          getAllUserDeptRelations().catch(() => ({ data: [] }))
        ])
        const userList = usersRes.data || []
        const departmentList = deptsRes.data || []
        const relations = relationsRes.data || []

        const deptUserMap = {}
        relations.forEach(r => {
          if (!deptUserMap[r.deptId]) deptUserMap[r.deptId] = []
          deptUserMap[r.deptId].push(r.userId)
        })
        const userMap = {}
        userList.forEach(u => { userMap[u.id] = u })

        this.usersByDept = departmentList.map(dept => ({
          deptId: dept.id,
          deptName: dept.deptName,
          users: (deptUserMap[dept.id] || []).map(uid => userMap[uid]).filter(Boolean)
        })).filter(g => g.users.length > 0)

        const assignedUserIds = new Set(relations.map(r => r.userId))
        const unassigned = userList.filter(u => !assignedUserIds.has(u.id))
        if (unassigned.length > 0) {
          this.usersByDept.push({
            deptId: 0,
            deptName: '未分配部门',
            users: unassigned
          })
        }
      } catch (e) {
        console.warn('加载用户列表失败', e)
      }
    },
    handleInput(val) {
      this.$emit('input', val)
    }
  }
}
</script>

<style scoped>
.risk-control-operator { padding: 4px 0; }
</style>
